



































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import UpdateLineItemDiscountTrigger from './UpdateLineItemDiscountTrigger.coffee'

settings =
  name: 'UpdateLineItemDiscountTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [UpdateLineItemDiscountTrigger.trigger()]

    computed:
      lineItem: -> @modal.config.lineItem

    methods:
      modalData: ->
        {
          discount_in_dollars: @lineItem.unit_discount_in_dollars
          discount_percentage: @lineItem.unit_discount_percentage
          discount_type: 'dollar'
          price_in_dollars: @lineItem.price_in_dollars
        }

      hiClose: ->
        @close()
        @resourceComponent?.creativeEditorModal?.show = true

export default VueOptions.vue settings
